import { Breadcrumb, Radio } from 'antd';
import { Link, useParams } from 'react-router';

import { useGetSchoolDataQuery } from '@/api/endpoints/schools';
import { DataSection, FetchDataWrapper, Title } from '@/shared/components';
import { ROUTES } from '@/shared/consts';
import { usePageTitle } from '@/shared/hooks';
import { ESchoolType } from '@/shared/types';

import { ESchoolTypeToText } from '../consts';

import { EditCorporateSchoolWrapper } from './EditCorporateSchoolWrapper';
import { EditPublicSchoolComponent } from './EditPublicSchoolComponent';
import styles from './SchoolEditPage.module.scss';

const SCHOOL_TYPE_TO_COMPONENT_MAPPER = {
  [ESchoolType.Public]: EditPublicSchoolComponent,
  [ESchoolType.Corporate]: EditCorporateSchoolWrapper,
};

export const SchoolEditPage = () => {
  usePageTitle('Редактирование школы');

  const { id: schoolId } = useParams();

  const {
    data: schoolData,
    isLoading: isSchoolDataLoading,
    isError: isSchoolDataFetchError,
  } = useGetSchoolDataQuery({ id: Number(schoolId) });

  return (
    <FetchDataWrapper
      isLoading={isSchoolDataLoading}
      isError={isSchoolDataFetchError}
    >
      {schoolData &&
        (() => {
          const schoolType = schoolData.school_type;

          const Component = SCHOOL_TYPE_TO_COMPONENT_MAPPER[schoolType];

          return (
            <div className={styles['page-wrapper']}>
              <Breadcrumb
                items={[
                  { title: 'Публичные страницы' },
                  { title: <Link to={`/${ROUTES.PUBLIC_PAGES}/${ROUTES.SCHOOLS}`}>Школы</Link> },
                  { title: schoolData.name },
                ]}
              />
              <div className={styles['status-wrapper']}>
                <Title>
                  Статус :{' '}
                  <span className={styles['status-unpublished']}>{ESchoolTypeToText.UnPublished.toUpperCase()}</span>
                </Title>
              </div>
              <DataSection titleText="Тип школы">
                <Radio.Group
                  className={styles['type-wrapper']}
                  options={[
                    { label: 'Публичная', value: ESchoolType.Public },
                    { label: 'Корпоративная', value: ESchoolType.Corporate },
                  ]}
                  value={schoolType}
                  disabled
                />
              </DataSection>
              <Component schoolData={schoolData} />
            </div>
          );
        })()}
    </FetchDataWrapper>
  );
};
